module.exports = __webpack_public_path__ + "static/media/Image2.05b4f435.JPG";